/**
 * Regex for E164 international phone number
 */
export default new RegExp('^[+]?([\\s0-9-()]{1,4})+$');
